import { useState, useCallback } from "react";

export const useAuth = () => {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const login = useCallback(() => {
    setLoggedIn(true);
  }, []);
  const logout = useCallback(() => {
    setLoggedIn(false);
  }, []);
  return { isLoggedIn, login, logout };
};
